import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { RetireGrant$ } from "../schemas/schemas_0";
export { $Command };
export class RetireGrantCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "RetireGrant", {})
    .n("KMSClient", "RetireGrantCommand")
    .sc(RetireGrant$)
    .build() {
}
